module.exports = __webpack_public_path__ + "img/horizontal_7_7_pp23_6000.d35080f1.png";